module.exports = __webpack_public_path__ + "img/Powerpack-image.488296da.png";